// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  // Paste your configuration here
  apiKey: "AIzaSyCRmfsC2Twr0sIxalhn3BtL8r75qSidS3M",
  authDomain: "faircast-a634c.firebaseapp.com",
  projectId: "faircast-a634c",
  storageBucket: "faircast-a634c.firebasestorage.app",
  messagingSenderId: "479928294296",
  appId: "1:479928294296:web:e32eb2b373bb37ef0fe9ed",
  measurementId: "G-CBB2DHL8CF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
